import {
  CIRCULAR_PROGRESS_BAR_SIZE_DIMENSIONS,
  CircularProgressBarProps,
  CircularProgressBarStartPosition,
} from "@/components/circularProgressBar/CircularProgressBar.types.ts";

import styles from "./CircularProgressBar.module.scss";

const STARTING_ROTATIONS: Record<CircularProgressBarStartPosition, number> = {
  top: 0,
  right: 90,
  bottom: 180,
  left: 270,
};

export const CircularProgressBar = ({
  value,
  variant = "full",
  size = "small",
  startPosition = variant === "half" ? "left" : "top",
  rotation = "clockwise",
  progressColor = styles.progress,
  backgroundColor = styles.background,
  text,
  textClassName = "pulseTextBodyBold",
  textColor = progressColor,
}: CircularProgressBarProps) => {
  const {radius, strokeWidth} = CIRCULAR_PROGRESS_BAR_SIZE_DIMENSIONS[size];
  const isHalf = variant === "half";
  const width = radius * 2 + strokeWidth;
  const height = isHalf ? radius + strokeWidth * 2 : width;
  const centerX = width / 2;
  const centerY = isHalf ? radius + strokeWidth : centerX;
  const circumference = Math.PI * radius * (isHalf ? 1 : 2);
  const progress = value * circumference;
  const rotationMultiplier = rotation === "counterclockwise" ? -1 : 1;
  const startRotation = STARTING_ROTATIONS[startPosition] + (isHalf ? rotationMultiplier * 90 : 0);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{transform: `rotate(${startRotation}deg)`, transformOrigin: "center"}}
    >
      <path
        d={
          isHalf
            ? `M ${strokeWidth / 2} ${centerY} A ${radius} ${radius} 0 0 1 ${width - strokeWidth / 2} ${centerY}`
            : `M ${centerX} ${strokeWidth / 2} A ${radius} ${radius} 0 1 1 ${centerX} ${width - strokeWidth / 2} A ${radius} ${radius} 0 1 1 ${centerX} ${strokeWidth / 2}`
        }
        fill="none"
        stroke={backgroundColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d={
          isHalf
            ? `M ${strokeWidth / 2} ${centerY} A ${radius} ${radius} 0 0 1 ${width - strokeWidth / 2} ${centerY}`
            : `M ${centerX} ${strokeWidth / 2} A ${radius} ${radius} 0 1 1 ${centerX} ${width - strokeWidth / 2} A ${radius} ${radius} 0 1 1 ${centerX} ${strokeWidth / 2}`
        }
        fill="none"
        stroke={progressColor}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={rotationMultiplier * (circumference - progress)}
        strokeLinecap="round"
      />
      {text && (
        <text
          x={centerX}
          y={centerY}
          textAnchor="middle"
          dominantBaseline="central"
          style={{transform: `rotate(${-startRotation}deg)`, transformOrigin: `${centerX}px ${centerY}px`}}
          className={textClassName}
          fill={textColor}
        >
          {text}
        </text>
      )}
    </svg>
  );
};
